import { render, staticRenderFns } from "./two-columns.vue?vue&type=template&id=39924fba&lang=pug&"
import script from "./two-columns.vue?vue&type=script&lang=js&"
export * from "./two-columns.vue?vue&type=script&lang=js&"
import style0 from "./two-columns.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports